import { Area, AreaChart, YAxis } from 'recharts';
import { ChartContainer } from '../tailgrids/core/chart.js';
import { type ChartTone, TONE_COLOR } from './chart-colors.js';

interface SparklineProps {
  values: readonly number[];
  /** Accessible name, e.g. "Cost, last 7 days". */
  title: string;
  tone?: ChartTone;
  height?: number;
  /** Fixed width in px; omit to fill the container. */
  width?: number;
}

/** A tiny trend line with no axes, for a table cell or a stat card. Fewer than two points draws nothing. */
export function Sparkline({ values, title, tone = 'accent', height = 32, width }: SparklineProps) {
  if (values.length < 2) return <span className="sr-only">{title}: not enough data</span>;
  const data = values.map((v, i) => ({ i, v }));
  return (
    <figure
      role="img"
      aria-label={`${title}: from ${values[0]} to ${values[values.length - 1]}`}
      className="m-0"
      style={{ height, width: width ?? '100%' }}
    >
      <ChartContainer width={width ?? '100%'} height={height}>
        <AreaChart data={data} margin={{ top: 2, right: 0, left: 0, bottom: 2 }}>
          <YAxis hide domain={['dataMin', 'dataMax']} />
          <Area
            type="monotone"
            dataKey="v"
            stroke={TONE_COLOR[tone]}
            fill={TONE_COLOR[tone]}
            fillOpacity={0.12}
            strokeWidth={1.5}
            dot={false}
            isAnimationActive={false}
          />
        </AreaChart>
      </ChartContainer>
    </figure>
  );
}
